export const toastCopyEnUs = {
    saved: "Saved",
    savedForNow: "Saved for now.",
    savedSuccessfully: "Saved successfully",
    errorSaving: "Error saving",
    errorSavingTracker: "Error saving tracker",
    updateFailed: "Update failed",
    errorUpdating: "Error updating",
    errorCreating: "Error creating",
    errorCreatingInput: "Error creating input",
    errorCreatingDiaryLog: "Error creating diary log",
    errorCreatingEvent: "Error creating event",
    errorUpdatingEvent: "Error updating event",
    errorUpdatingProfile: "Error updating profile, please try again",
    errorWhileUploading: "Error while uploading",
    refreshAndRetry: "Error, please refresh and retry",
    noDataReturned: "No data returned",
    settingsSaved: "Settings saved",
    copiedToClipboard: "Copied to clipboard",
    linkCopiedToClipboard: "Link copied to clipboard",
    pleaseSelectFile: "Please select a file",
    pasteImageFromClipboard: "Paste an image from your clipboard (Ctrl+V or Cmd+V)",
    loggedOutSuccess: "Successfully logged out",
    loggingIn: "Logging in",
    errorLoggingIn: "Error logging in",
    loginSuccessful: "Login successful",
    signUpSuccessful: "Sign-up successful",
    transferRequested: "Transfer requested - please check your email to ensure it went through.",
    organisationAdded: "Organization added",
    organisationAlreadyAdded: "Organization already added",
    deletionRequestSent: "Deletion Request Sent",
    userAuthenticated: "User Authenticated",
    codeIncorrect: "Code incorrect",
    codeCorrect: "Code correct",
    errorSigningIn: "Error signing in",
    otpFailedToSend: "One Time Password Failed to Send",
    passwordUpdatedSuccess: "Password updated successfully!",
    emailOrPasswordIncorrect: "Email or password incorrect",
    phoneNumberConfirmed: "Phone number confirmed",
    errorConfirmingPhoneNumber: "Error confirming phone number",
    profileUpdatedSuccess: "Successfully updated profile",
    professionalDetailsSaved: "Professional details saved!",
    failedUpdateProfessionalDetails: "Failed to update professional details",
    templateCreatedSuccess: "Template created successfully!",
    templatesCreatedSuccess: (count) =>
        count === 1 ? "Template created successfully!" : `${count} templates created successfully!`,
    failedCreateTemplate: "Failed to create template",
    templateUpdatedSuccess: "Template updated successfully",
    failedUpdateTemplate: "Failed to update template",
    templateDeletedSuccess: "Template deleted successfully",
    failedDeleteTemplate: "Failed to delete template",
    templateDuplicatedSuccess: "Template duplicated successfully",
    failedDuplicateTemplate: "Failed to duplicate template",
    templateSharedSuccess: "Template shared successfully",
    errorSharingTemplate: (message) => `Error sharing template: ${message}`,
    analyticsViewSharedSuccess: "View shared successfully",
    errorSharingAnalyticsView: (message) => `Error sharing view: ${message}`,
    analyticsViewUnsharedSuccess: "Shared view removed",
    errorUnsharingAnalyticsView: (message) => `Error removing shared view: ${message}`,
    trackerSaved: "Tracker saved",
    entryUpdatedSuccess: "Entry updated successfully",
    entrySaved: "Entry saved",
    entryDeleted: "Entry deleted",
    entryTimingUpdated: "Entry timing updated",
    scheduleUpdated: "Schedule updated",
    entryRemovedFromSchedule: "Entry removed from schedule",
    entryAssignedToScheduleStep: "Entry assigned to schedule step",
    stepAlreadyOccupied: "That step already has an entry.",
    diaryUpdatedSuccess: "Diary updated successfully",
    diaryInputsAddedSuccess: "Diary inputs added successfully",
    diaryDiscardedSuccess: "Diary discarded successfully",
    diaryReinstatedSuccess: "Diary reinstated successfully",
    diaryDischargedSuccess: "Diary discharged successfully",
    diaryEnded: "Diary ended",
    labelCreated: "Label created",
    labelUpdated: "Label updated",
    labelDeleted: "Label deleted",
    labelsUpdated: "Labels updated",
    tableSettingsSaved: "Table settings saved",
    detailsSaved: "Your details have been saved.",
    hospitalNumberRequired: "Hospital number is required",
    couldNotSaveHospitalNumber: "Could not save hospital number",
    sharedAttributesUpdated: "Shared attributes updated",
    errorUpdatingSharedAttributes: "Error updating shared attributes",
    sharedAttributesCreated: "Shared attributes created",
    errorCreatingSharedAttributes: "Error creating shared attributes",
    diaryAccessSaved: "Diary access saved",
    failedSaveDiaryAccess: "Failed to save diary access",
    joinedDateGroupSuccess: "Joined date group successfully",
    failedJoinDateGroup: (message) => `Failed to join date group: ${message}`,
    questionnaireStopped: "Questionnaire stopped",
    errorStoppingQuestionnaire: "Error stopping questionnaire",
    consentAddedToDiary: "Consent added to diary",
    errorAddingConsentToDiary: "Could not add consent",
    eventSaved: "Event saved",
    eventUpdated: "Event updated",
    eventDeletedSuccess: "Event deleted successfully",
    eventTrackerLinked: "Event and tracker linked",
    errorLinkingEventTracker: (message) => `Error linking event and tracker. ${message}`,
    surgerySaved: "Surgery saved",
    errorCreatingSurgery: "Error creating new surgery",
    surgeryOptionUpdated: "Surgery option updated",
    errorUpdatingSurgeryOption: "Error updating surgery option",
    newSurgeryOptionSaved: "New surgery option saved",
    consultationSaved: "Consultation saved",
    errorCreatingConsultation: "Error creating new consultation",
    errorUpdatingConsultation: "Error updating consultation",
    imagingRequestSaved: "Imaging request saved",
    errorCreatingImagingRequest: "Error creating imaging request",
    injectionDetailsUpdated: "Injection details updated",
    errorUpdatingInjectionDetails: "Error updating injection details",
    injectionDiaryDefaultSaved: "Injection diary default saved",
    errorSavingInjectionDiaryDefault: "Error saving injection diary default",
    diaryInjectionAdded: "Diary injection added",
    errorCreatingDiaryInjection: "Error creating diary injection",
    injectionContentUpdated: "Injection content updated",
    failedUpdateInjectionContent: "Failed to update injection content",
    injectionContentDeleted: "Injection content deleted",
    failedDeleteInjectionContent: "Failed to delete injection content",
    approvedStatusUpdated: "Approved status updated",
    failedUpdateApprovedStatus: "Failed to update approved status",
    publishedStatusUpdated: "Published status updated",
    failedUpdatePublishedStatus: "Failed to update published status",
    injectionLocationUpdated: "Injection location updated",
    failedUpdateInjectionLocation: "Failed to update injection location",
    newInjectionLocationCreated: "New injection location created",
    failedCreateInjectionLocation: "Failed to create injection location",
    newInjectionContentsCreated: "New injection contents created",
    failedCreateInjectionContents: "Failed to create injection contents",
    failedSaveInjectionDetails: "Failed to save injection details",
    diaryShockwaveAdded: "Diary shockwave added",
    errorCreatingDiaryShockwave: "Error creating diary shockwave",
    diaryShockwaveSaved: "Diary shockwave saved",
    shockwaveDetailsUpdated: "Shockwave details updated",
    errorUpdatingShockwaveDetails: "Error updating shockwave details",
    shockwaveDiaryDefaultSaved: "Shockwave diary default saved",
    errorSavingShockwaveDiaryDefault: "Error saving shockwave diary default",
    shockwaveDetailsRemoved: "Shockwave details removed",
    failedSaveShockwaveDetails: "Failed to save shockwave details",
    scheduleUpdatedSuccess: "Schedule updated successfully",
    failedUpdateSchedule: "Failed to update schedule",
    scheduleDraftCreated: "Draft schedule created",
    failedCreateScheduleFromDraft: "Failed to create schedule from draft",
    failedUpdatePublishStatus: "Failed to update publish status",
    formUpdated: "Form updated",
    failedUpdateForm: "Failed to update form",
    formDraftCreated: "Draft form created",
    failedCreateFormFromDraft: "Failed to create form from draft",
    pageSaved: "Page saved",
    failedSavePage: "Failed to save page",
    pageDeleted: "Page deleted",
    failedDeletePage: "Failed to delete page",
    questionSaved: "Question saved",
    failedSaveQuestion: "Failed to save question",
    questionDeleted: "Question deleted",
    failedDeleteQuestion: "Failed to delete question",
    patientAddedSuccess: "Patient added successfully!",
    emailWordsUpdatedSuccess: "Successfully updated email words",
    failedUpdateEmailWords: "Failed to update email words",
    emailSentSuccess: "Email sent successfully",
    diaryAlreadyRead: "Diary already read",
    noLastReadAction: "No last read action found",
    actionComplete: (actionName) => `${actionName} Complete`,
    footLogCreatedSuccess: "Successfully created foot log",
    imageUploadedSuccess: "Successfully uploaded image",
    imageLabelCreatedSuccess: "Successfully created image label",
    qipPermissionsUpdated: "QIP permissions successfully updated",
    qipPermissionsUpdateFailed: "QIP permissions update failed",
    riskAssessmentUpdateFailed: "Risk assessment update failed",
    footCommentSubmitted: (comment) => `You submitted the following comment:\n${comment}`,
    qrCodeNotReady: "QR code not ready",
    qrCodeCopiedToClipboard: "QR code copied to clipboard",
    couldNotCopyQrImage: "Could not copy QR image. Try a screenshot instead.",
    inviteSent: "Invite sent",
    organisationRoleAddedSuccess: "Organization role added successfully",
    errorAddingOrganisationRole: (message) => `Error adding organization role: ${message}`,
    organisationRoleUpdatedSuccess: "Organization role updated successfully",
    errorUpdatingOrganisationRole: (message) => `Error updating organization role: ${message}`,
    organisationRoleDeletedSuccess: "Organization role deleted successfully",
    errorDeletingOrganisationRole: (message) => `Error deleting organization role: ${message}`,
    secretaryAddedToOrganisation: "Secretary assignment added",
    errorAddingSecretaryToOrganisation: (message) => `Error adding secretary assignment: ${message}`,
    defaultSecretarySet: "Default contact person updated",
    errorSettingDefaultSecretary: (message) => `Error setting default contact person: ${message}`,
    defaultSecretaryCleared: "Default contact person cleared",
    errorClearingDefaultSecretary: (message) => `Error clearing default contact person: ${message}`,
    secretaryRemovedFromOrganisation: "Secretary assignment removed",
    errorRemovingSecretaryFromOrganisation: (message) => `Error removing secretary assignment: ${message}`,
    newOrganisationSaved: "New organization saved",
    organizationCreatedSuccess: "Organization created successfully!",
    audiencesUpdatedSuccess: "Successfully updated audiences",
    errorUpdatingAudiences: "Error updating audiences",
    labelAccessUpdated: "Label access updated",
    accessUpdated: "Access updated",
    photoUpdatedSuccess: "Photo updated successfully",
    failedUpdatePhoto: "Failed to update photo",
    photoDeletedSuccess: "Photo deleted successfully",
    failedDeletePhoto: "Failed to delete photo",
    logoUpdatedSuccess: "Logo updated successfully",
    failedUpdateLogo: "Failed to update logo",
    logoDeletedSuccess: "Logo deleted successfully",
    failedDeleteLogo: "Failed to delete logo",
    smsDisabledInKnock: "SMS disabled in Knock",
    failedUpdateKnockPreferences: "Failed to update Knock preferences",
    magicLinkGenerated: "Magic Link Generated",
    errorImpersonatingUser: "Error impersonating user",
    fieldUpdatedSuccess: (field) => `${field} has been updated successfully.`,
    lockUnlockReasonRequired: (action) => `${action === "lock" ? "Sign-off" : "Unlock"} reason is required`,
    lockUnlockSuccess: (action, count) => `${action === "lock" ? "Locked" : "Unlocked"} ${count} diaries`,
    errorResolvedSuccess: "Error resolved successfully",
    failedResolveError: (message) => `Failed to resolve error: ${message}`,
    healthCheckCompleted: (message) => `Health check completed: ${message}`,
    healthCheckFailed: (message) => `Health check failed: ${message}`,
    expectedCountUpdatedSuccess: "Expected count updated successfully",
    failedUpdateExpectedCount: (message) => `Failed to update expected count: ${message}`,
    fixedRecords: (fixed, failed) => `Fixed ${fixed} records${failed ? `, ${failed} failed` : ""}`,
    failedFixSharedAttributes: (message) => `Failed to fix shared attributes: ${message}`,
    failedAssignRole: (message) => `Failed to assign role: ${message}`,
    failedLoadMessages: "Failed to load messages",
    loggedInSuccess: "Successfully logged in",
    unknownLoginError: "Unknown login error",
    userDeleted: "User deleted",
    passwordSetSuccess: "Password set successfully!",
    emailVerificationSent: "Email Verification Sent",
    verificationCodeSent: "Verification code sent",
    verificationCodeSentEmail: "Verification code sent to your email",
    failedSendVerificationCode: "Failed to send verification code",
    emailVerificationFailed: "Email Verification Failed",
    emailVerified: "Email Verified",
    emailVerifiedShort: "Email verified!",
    invalidVerificationCode: "Invalid verification code",
    emailSetSuccess: "Email set successfully",
    emailSavedToProfileToast: "Email saved to your profile",
    emailUpdatedSuccessToast: "Email updated successfully",
    superUserStatusUpdated: "Super user status updated",
    userInvited: "User invited",
    profileAttributeLocked: "Profile attribute is locked",
    addressAlreadyInUse: "That address is already in use.",
    mustBeSignedIn: "You must be signed in.",
    contactPersonRequired: "Contact person is required.",
    somethingWentWrong: "Something went wrong. Please try again.",
    resultsSentToEmail: "Results sent to your email!",
    resultsEmailSendFailed: "Your results are ready, but we could not send the email. Please try again later.",
    fixHighlightedFieldsBeforeInvite: "Please fix the highlighted fields before sending the invite.",
    pdfDownloaded: "PDF downloaded",
    pdfDownloadFailed: "PDF download failed",
    pdfGenerationFailed: "PDF generation failed",
    questionnaireResumed: "Questionnaire resumed",
    errorResumingQuestionnaire: "Error resuming questionnaire",
    trackerDeletedSuccess: "Tracker deleted successfully",
    diaryCreatedSuccess: "Diary created successfully",
    diaryDeletedSuccess: "Diary deleted successfully",
    templateSavedSuccess: "Template saved successfully",
    failedSaveTemplate: "Failed to save template",
    diaryAccessRemoved: "Diary access removed",
    failedRemoveDiaryAccess: "Failed to remove diary access",
    entryRemindersTriggered: "Entry reminders triggered for tracker",
    correctionSaved: "Correction saved",
    correctionReasonRequired: "Correction reason is required",
    errorAddingPatient: "Error adding patient, please refresh and try again.",
    invalidDate: "Invalid date",
    failedCreateDiary: (message) => `Failed to create diary: ${message}`,
    failedUpdateEntry: (message) => `Failed to update entry: ${message}`,
    failedDeleteSchedule: (message) => `Failed to delete schedule: ${message}`,
    failedCopySchedule: (message) => `Failed to copy schedule: ${message}`,
    errorAddingUserToOrganisation: (message) => `Error adding user to organization: ${message}`,
    emailRequiredRefresh: "We need your email to continue. Please refresh the page and submit the form again.",
    templateStillLoading: "Still loading template. Please try again in a moment.",
    phoneUpdatedSuccess: "Phone updated successfully",
    failedUpdatePhone: "Failed to update phone. Please try again.",
    completeRequiredFields: (fieldsList) => `Please complete the following required fields:\n${fieldsList}`,
    missingEntry: "Missing entry",
    formSubmissionError: (message) => `Form submission error: ${message}`,
    organisationDeleted: "Organization deleted",
    noRowsToExport: "No rows on this page to export",
    exportedChangeEventsFromPage: (count) => `Exported ${count} change events from this page`,
    noChangeEventsMatchFilters: "No change events match these filters",
    exportedChangeEvents: (count) => `Exported ${count} change events`,
    mustSignInToExportSnapshot: "You must be signed in to export a snapshot",
    noDiariesToExport: "No diaries to export - adjust the search or filters first",
    chooseSnapshotDateTime: "Choose an as-of date and time for the snapshot",
    snapshotExported: (count, dateTime) =>
        count === 1
            ? `Snapshot exported for 1 diary as of ${dateTime} UTC`
            : `Snapshot exported for ${count} diaries as of ${dateTime} UTC`,
    snapshotExportFailed: "Snapshot export failed",
    exportFailed: "Export failed",
    exportedChangeEventsTruncated: (exported, total) =>
        `Exported first ${exported} of ${total} matching change events (10,000 row limit)`,
    printing: "Printing",
    failedGeneratePrintUrl: "Failed to generate print URL",
    reportPrintQueued:
        "Report queued. It will be generated on the server shortly - try printing again in a few minutes.",
    reportPrintRendering: "Generating your report...",
    reportPrintRefreshing: "Diary updated - generating a fresh report...",
    reportPrintPreparing: "Preparing your report...",
    reportPrintTimeout: "Report is taking longer than expected. Please try print again in a few minutes.",
    unknownError: "Unknown error",
    failedCreateOrganisation: "Failed to create organization",
    correctionFailed: "Correction failed",
    couldNotSaveProcedureDate: "Could not save your procedure date",
    couldNotSave: "Could not save",
    invalidFieldSelection: "One or more fields have an invalid selection - please check the form and try again.",
    completeAllRequiredFieldsBeforeSaving: "Please complete all required fields before saving.",
    detailsAlreadySaved: "These details have already been saved.",
    unableToSaveInjectionDetails: "Unable to save injection details. Please check your entries and try again.",
    unableToSaveShockwaveDetails: "Unable to save shockwave details. Please check your entries and try again.",
    invitationLinkExpired: "That invitation link has expired. Enter your email to get a new code.",
    invitationLinkInvalid: "That link is invalid or has expired. Enter your email to get a new code.",
    confirmAccountCouldNotTextTryEmail:
        "We could not send a text to this number. Try the email from your invitation if you have one.",
    confirmAccountNoAccountForDetails:
        "We could not find an account for those details. Please check or speak to the team who invited you if you need help.",
    smsVerificationUnavailableForNumber:
        "SMS verification is not available for this number yet. Use the email from your invitation, or speak to the team who invited you.",
    smsVerificationTextFailedSignup:
        "We could not send a verification text to this number. If you have an account, try signing in with your email, or ask the team who invited you for help.",
    smsSignInNotEnabledForProject:
        "SMS sign-in is not enabled for this project. The team who invited you or support can help.",
    smsCouldNotSendCheckNumber:
        "We could not send a text to this number. Check the number, try email sign-in, or speak to the team who invited you.",
    smsLoginTextFailedOtpDisabled:
        "We found your account, but could not send a login text. Sign in with your email and password, or speak to the team who invited you if you need help.",
    smsLoginTextFailedAccountFound:
        "We found your account, but could not send a login text to this number. Sign in with your email, or speak to the team who invited you if you need help with SMS.",
    clinicianUpdateFailedDescription: "Failed to update clinician. Please try again.",
    lockUnlockPartialFailure: (action, succeeded, failed, failedNames, firstError) =>
        `${action === "lock" ? "Locked" : "Unlocked"} ${succeeded}, failed ${failed}: ${failedNames} (${firstError})`,
    rolesAssignedToUsers: (role, assigned, failed) =>
        `Assigned ${role} to ${assigned} users${failed ? `, ${failed} failed` : ""}`,
    pdfDownloadFailedDescription: "Failed to download the generated PDF",
    pdfGenerationFailedDescription: "Failed to generate PDF",
    pdfDownloadSuccessDescription: "Your PDF has been downloaded successfully.",
};
